import './App.css';
import Link from '@mui/material/Link';
import Button from '@mui/material/Button';

function App() {
  const emailToLegislatorMap = {
    // 'Castaictowncouncil@gmail.com': 'Castaic City Council',
    'https://cdiapps.insurance.ca.gov/contactus/default.aspx':
      'Dept of Insurance', //Ricardo Lara
    'kathryn@bos.lacounty.gov': 'Kathryn Barger',
    'assemblymember.valladares@assembly.ca.gov': 'Suzette Valladares',
    'senator.wilk@senate.ca.gov': 'Scott Wilk',
    'https://govapps.gov.ca.gov/gov40mail/': 'Gavin Newsome',
    'info@alex-padilla.com': 'Alex Padilla',
    'info@electmikegarcia.com': 'Mike Garcia',
  };

  const LETTER = `
Dear <<official-name>>,
I am writing to raise awareness and seek immediate assistance.
As a resident in southern California, I have faced an exorbitant increase in property/ fire insurance rates over the past two years. I live in a condo community and our master insurance policy has historically been $43,000. In 2021, our rate increased to $285,674. This is an increase of 564% from one year to the next. This in itself is price gouging and unacceptable. This year, yet again, we faced a 50% increase from last year’s exorbitant policy.
To put it in context, 2 years ago I was paying $473 a year for insurance, I am now paying $4,718, that is an increase of 897%.
This is obscene. By law, Property taxes in California cannot increase by more than 1% of property value, why is it legal for an insurance company to hike my rates by almost 1,000%? As you are aware, the  cost of living in California is expensive but there should be no question that these unfair practices should be illegal and Californians should be protected from them.
We are submitting a complaint to the dept of insurance again regarding this matter.
There is not enough emphasis or effort on resolving this matter for residents of California. As your constituent, please take this under immediate review and take swift actions to rectify these unfair practices.

A response of acknowledgement and next steps is appreciated (and expected).

Thank you for your attention to this matter,
`;

  const body = LETTER.split('\n').filter(v => v);

  console.log(body);

  const getEmailBody = name =>
    body.join('%0D%0A%0D%0A').replace('<<official-name>>', name);

  const createMailToString = (name, email) => {
    return `mailto:${email}?subject=Fire Insurance Rates - Price Gouging&body=${getEmailBody(
      name
    )}`;
  };

  return (
    <div
      className="App"
      style={
        {
          // backgroundImage: `url('/castiac.jpg')`,
          // height: '100vh',
          // backgroundPosition: 'center',
          // backgroundRepeat: 'no-repeat',
          // backgroundSize: 'cover',
        }
      }
    >
      <div className="bg-card">
        <h1 className="title">
          Cimarron Oaks Community- Fire Insurance Special Assessment!
        </h1>
      </div>
      <iframe
        width="95%"
        height="225"
        src="https://www.youtube.com/embed/UrZ1BwTbAQY"
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      ></iframe>
      <p className="bg-card content left-align">
        To the Residents of Cimarron Oaks Community,
        <br />
        <br />
        Our condo community has been hit hard over the past couple years by
        sharp increases in our insurance policy, specifically, due to fire
        insurance.
        <br /> <br />
        This year, our HOA secured a new annual policy (2022- 2023) at a cost of
        $429,369. To cover the cost of this new policy, each unit was recently
        imposed with special assessments totaling $4718/ year (this is on top of
        normal monthly dues).
        <br /> <br />
        These insurance rate hikes may continue year after year and are not
        sustainable. This is not just a Cimarron Oaks problem, this is a Castaic
        problem, and a California problem. We are asking neighbors and community
        members to get involved and write to our elected officials to ask they
        prioritize and urgently review this issue.
        <br /> <br />
        Below you will find email templates and contact info for local, state,
        and federal policy makers… to empower you to easily send emails to voice
        concern to those in power representing Castaic on a county, state, and
        federal level.
        <br /> <br />
        Please take a few minutes of your day to contact these individuals. One
        or two people may not be taken seriously, but if every adult in each
        household makes their voice heard, hopefully we can gain some traction.
        Many of them are also up for reelection this year. Have your voice heard
        - these rate hikes are not sustainable, not fair, and our legislators to
        provide solutions now! If you have questions, contact:{' '}
        <Link underline="none" href="mailto:91384Fireins@gmail.com">
          91384Fireins@gmail.com
        </Link>
      </p>

      <div className="email-buttons">
        {Object.entries(emailToLegislatorMap)
          .filter(([email]) => email)
          .map(([email, name]) => {
            const isEmail = email.endsWith('com') || email.endsWith('gov');
            console.log(email, isEmail);
            return (
              <Button key={email} variant="contained" className="email-button">
                <Link
                  href={isEmail ? createMailToString(name, email) : email}
                  color="inherit"
                  target={isEmail ? '' : '_blank'}
                  underline="none"
                >
                  {isEmail ? 'Email' : 'Contact'} {name}
                </Link>
              </Button>
            );
          })}
      </div>
    </div>
  );
}

export default App;
